import { handleDeleteSession } from '../../../api/grt/ai';

import s from './style.module.scss';
import { Tooltip } from 'antd';
import { useEffect } from 'react';
import ToastUtils from '../../../utils/ToastUtils';
import { ConfirmTip } from '@/utils/Web';
import MyIcon from '@/components/MyIcon';
import { inject, observer } from 'mobx-react';
import { clearReportsForSession } from '../../hooks/DeerFlow/useReportUtils';
const SessionList = (props) => {
    const { sessionStore } = props.store;
    const { sessionId, userId } = props;
    const { sessionList = {}, originalSessionList = [] } = sessionStore;
    const choseItem = (item) => {
        props.changeSession(item);
    };
    const getSessionList = () => {
        props.getHistorySessionList();
    };
    const handleDelete = async (id) => {
        if (id === -1) {
            return false;
        }

        // 🔥 修复：删除会话前检查是否是当前会话
        const isCurrentSession = id === sessionId;

        let res = await handleDeleteSession({ session_id_list: [id] });
        if (res && res.success) {
            ToastUtils.showToast('删除成功');

            // 🔥 新增：清理该会话下的所有本地报告数据
            clearReportsForSession(id);

            // 🔥 修复：如果删除的是当前会话，需要关闭侧边栏并重置会话
            if (isCurrentSession) {
                // 派发关闭侧边栏事件
                window.dispatchEvent(
                    new CustomEvent('close-report-sidebar', {
                        detail: {
                            reportId: id,
                            reason: 'session_deleted'
                        }
                    })
                );

                // 重置会话状态
                if (props.resetSession) {
                    props.resetSession();
                }
            }

            getSessionList();
        } else {
            ToastUtils.showAbnormalToast(res?.msg || '删除失败');
        }
    };
    const beforeDelete = (item) => {
        // if (item.session_id === sessionId && props.isInAnswer) {
        //     ToastUtils.showToast('当前正在生成结果，请稍后操作');
        //     return false;
        // }
        ConfirmTip({
            icon: null,
            title: '确定删除？',
            content: ' 此操作将永久删除您创建的所有聊天记录，且无法撤销。请确认以继续。',
            onOk: handleDelete.bind(null, item.session_id)
        });
    };
    const activeDay = () => {
        let obj = originalSessionList.find((ele) => sessionId === ele.session_id);

        if (obj) {
            return obj?.time_range;
        } else {
            return null;
        }
    };
    useEffect(() => {
        if (userId) {
            getSessionList();
        }
    }, [userId]);
    return (
        <div className={s['session-list-box']}>
            <div className={s['latest-session-box']}>
                <div className={s['title']}>最近会话</div>
            </div>
            <div className={s['session-list-wrap']}>
                {Object.keys(sessionList).map((ele, index) => {
                    let obj = sessionList[ele];
                    return obj?.list.length ? (
                        <div className={s['session-group']} key={index}>
                            <div data-active={activeDay() === String(ele)} className={s['title']}>
                                <MyIcon className={s['title-icon']} type={obj.icon}></MyIcon>
                                <span>{obj?.name}</span>
                            </div>
                            <div className={s['session-item-wrap']}>
                                {obj?.list.map((item, idx) => {
                                    return (
                                        <div
                                            key={idx}
                                            data-checked={item.session_id === sessionId}
                                            className={s['session-item']}
                                            onClick={() => {
                                                choseItem(item);
                                            }}
                                        >
                                            <Tooltip title={item.session_name}>
                                                <span className={s['item-name']}> {item.session_name}</span>
                                            </Tooltip>

                                            <span
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    beforeDelete(item);
                                                }}
                                                className={s['item-action']}
                                            >
                                                <MyIcon className={s['action-icon']} style={{ fontSize: '22px' }} type="icon-agent-delete"></MyIcon>
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ) : null;
                })}
            </div>
            <div></div>
        </div>
    );
};
export default inject('store')(observer(SessionList));
